import axios from '@/libs/api.request'
import { getToken } from '@/libs/util'
import config from '@/config'

// const projectflowBaseUrl = 'http://127.0.0.1:8002/api/1.0/flow/'
// 持续发布基础URL
const backupStorageApi = config.backupStorageApi

const baseHeaders = {
  'Authorization': 'OPS ' + getToken()
}

export const storageServer = (params) => {
  return axios.request({
    url: `${backupStorageApi}/storage-server`,
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const InsertStorageServer = (data) => {
  return axios.request({
    url: `${backupStorageApi}/storage-server`,
    headers: baseHeaders,
    data: data,
    method: 'post'
  })
}

export const UpdateStorageServer = (data) => {
  return axios.request({
    url: `${backupStorageApi}/storage-server`,
    headers: baseHeaders,
    data: data,
    method: 'put'
  })
}

export const DeleteStorageServer = (data) => {
  return axios.request({
    url: `${backupStorageApi}/storage-server`,
    headers: baseHeaders,
    data: data,
    method: 'delete'
  })
}

export const connectivity = (params) => {
  return axios.request({
    url: `${backupStorageApi}/storage-server/connectivity`,
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const storageMedia = (params) => {
  return axios.request({
    url: `${backupStorageApi}/storage-media`,
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const InsertStorageMedia = (data) => {
  return axios.request({
    url: `${backupStorageApi}/storage-media`,
    headers: baseHeaders,
    data: data,
    method: 'post'
  })
}

export const UpdateStorageMedia = (data) => {
  return axios.request({
    url: `${backupStorageApi}/storage-media`,
    headers: baseHeaders,
    data: data,
    method: 'put'
  })
}

export const DeleteStorageMedia = (data) => {
  return axios.request({
    url: `${backupStorageApi}/storage-media`,
    headers: baseHeaders,
    data: data,
    method: 'delete'
  })
}

export const SysUserOperaLog = (params) => {
  return axios.request({
    url: `${backupStorageApi}/sys-user-opera-log`,
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const storageMediaType = (params) => {
  return axios.request({
    url: `${backupStorageApi}/storage-media-type`,
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}
